export const WEBSITE_CUSTOMIZATIONS = {
  colors: [
    {
      title: 'Indigo',
      primaryColor: '#283566',
      secondaryColor: '#986424'
    },
    {
      title: 'Han blue',
      primaryColor: '#3A5BCC',
      secondaryColor: '#898989',
    },
    {
      title: 'Orchid pink',
      primaryColor: '#E33665',
      secondaryColor: '#898989',
    },
    {
      title: 'Basque green',
      primaryColor: '#5A5E32',
      secondaryColor: '#DBC75B',
    },
    {
      title: 'Red berry',
      primaryColor: '#5F1928',
      secondaryColor: '#DE87C2',
    },
    {
      title: 'Purplish blue',
      primaryColor: '#5833F1',
      secondaryColor: '#898989',
    },
    {
      title: 'Obsidian shell',
      primaryColor: '#821FA0',
      secondaryColor: '#F4C730',
    },
    {
      title: 'Beagle brown',
      primaryColor: '#8D6D36',
      secondaryColor: '#9EBD59',
    },
  /*  {
      title: 'Chinese plant',
      primaryColor: '#9EBD59',
      secondaryColor: '#DEBF15',
    },*/
    {
      title: 'Aurora orange',
      primaryColor: '#ED6744',
      secondaryColor: '#A7A2A0',
    },
  ],
  themes: [
    {
      title: 'text_classic',
      class: 'classic'
    },
    {
      title: 'text_flat',
      class: 'flat'
    },
    {
      title: 'text_material',
      class: 'material'
    },
    {
      title: 'text_minimalistic',
      class: 'minimalistic'
    },
    {
      title: 'text_soft',
      class: 'soft'
    }
  ]
};
